import React from 'react';
import PropTypes from 'prop-types';
import { Config, I18nContext } from '@deporvillage/utils-library-component';
import Picture from '@deporvillage/picture-component';

const HeaderLogo = ({ wrapper, size }) => {

    const { url } = React.useContext(Config);
    const { translate } = React.useContext(I18nContext);

    const content = (
        <a className={ 'header-logo-component' } title={ translate('header.logo.title') } href={ url }>
            <Picture src={ '/static/default/deporvillage.png' }
                     height={ size.height } width={ size.width } quality={ 90 }/>
        </a>
    );

    return wrapper ? wrapper(content) : content;
};

HeaderLogo.propTypes = {
    size: PropTypes.shape({
        height: PropTypes.number,
        width: PropTypes.number,
    }),
    wrapper: PropTypes.func,
};

export default HeaderLogo;
